import axios from 'axios';
import _ from 'lodash';
import config from '../utils/config';

const getStates = async () => {
  const accessToken = await window.localStorage.getItem('access_token');
  const response = await axios.request({
    url: `${config.serverBasePath}/api/v2/udc/setting?setting_id=2`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      withCredentials: true,
      Authorization: `Bearer ${accessToken}`,
      'Access-Control-Allow-Origin': '*'
    },
  });
  return _.get(response, ['data', 'config'], {});
};

export default getStates;
